export const CLIENT_ID_KEY = "client_id";
export const EXPIRY_TIME_IN_MINUTES = 120; // in minutes
export const SETTINGS_KEY = "settings";
// features settings
export const EXPERIMENTAL_FEATURES_KEY = "is_experimental_features_enabled";
// query research settings
export const DO_EXPLICIT_WEB_SEARCH_KEY = "do_explicit_web_search";
export const ENABLE_SEARCH_LOCALIZATION_KEY = "enable_search_localization";
// optimize content settings
export const SHARE_OF_CITATIONS_THRESHOLD_KEY = "share_of_citations_threshold";
export const URL_CITATION_SHARE_THRESHOLD_KEY = "url_citation_share_threshold";
export const CITATION_WINDOW_KEY = "citation_window";
export const DISTANCE_THRESHOLD_KEY = "distance_threshold";
// Answer Engine
export const ANSWER_ENGINE_ENABLED_KEY = "answer_engine_enabled";
export const ANSWER_ENGINE_PROJECT_ID_KEY = "answer_engine_project_id";
export const ANSWER_ENGINE_VERSION_ID_KEY = "answer_engine_version_id";
export const ANSWER_ENGINE_SANDBOX_BKGD_KEY = "answer_engine_sandbox_bkgd";
export const VALID_ANSWER_ENGINE_TABS = new Set([
  "sandbox",
  "knowledge-base",
  "ae-queries",
  "chat-sessions",
  "analytics",
]);
export const ELELEM_ASSISTANT_MODE_KEY = "elelem_assistant_mode";
export const ELELEM_ASSISTANT_SHOW_STEPS_KEY = "elelem_assistant_show_steps";
export const ELELEM_ASSISTANT_CONVERSATION_ID_KEY = "elelem_assistant_conversation_id";
export const ELELEM_ASSISTANT_HISTORY_WIDTH_KEY = "elelem_assistant_history_width";
export const ELELEM_ASSISTANT_STUDIO_WIDTH_KEY = "elelem_assistant_studio_width";
export const ELELEM_ASSISTANT_SIDEBAR_WIDTH_KEY = "elelem_assistant_sidebar_width";
export const ELELEM_ASSISTANT_STUDIO_ENTITY_KEY = "elelem_assistant_studio_entity";
export const ASSISTANT_MODE_BOTTOM_RIGHT = "bottom-right";
export const ASSISTANT_MODE_SPOTLIGHT = "spotlight";
export const DEFAULT_ASSISTANT_HISTORY_WIDTH = 260;
export const DEFAULT_ASSISTANT_STUDIO_WIDTH = 430;
export const DEFAULT_ASSISTANT_SIDEBAR_WIDTH = 400;
export const MIN_ASSISTANT_HISTORY_WIDTH = 200;
export const MAX_ASSISTANT_HISTORY_WIDTH = 450;
export const MIN_ASSISTANT_STUDIO_WIDTH = 300;
export const MAX_ASSISTANT_STUDIO_WIDTH = 1400;
export const MIN_ASSISTANT_SIDEBAR_WIDTH = 340;
export const MAX_ASSISTANT_SIDEBAR_WIDTH = 850;
// Assets
export const DEFAULT_AVATAR_URL = "https://cdn.geo.elelem.ai/user.png";

// Other constants
export const DAY_OPTIONS = [
  { value: 7, label: "Last Week" },
  { value: 14, label: "Last 2 Weeks" },
  { value: 30, label: "Last Month" },
  { value: 90, label: "Last 3 Months" },
  { value: 180, label: "Last 6 Months" },
  { value: 365, label: "Last Year" },
];

// Brand colors / gradient
export const BRAND_COLOR_1 = "#2DC6FE";
export const BRAND_COLOR_2 = "#81FBEF";
export const BRAND_GRADIENT =
  "linear-gradient(90deg, #2DC6FE 0%, #81FBEF 100%)";

// Proactive Session Refresh Constants
export const AUTH_REFRESH_BUFFER_SECONDS = 30;
export const AUTH_REFRESH_RETRY_DELAY_MS = 15000;
export const AUTH_REFRESH_MIN_DELAY_MS = 1000;
export const AUTH_REFRESH_MAX_RETRIES = 3;
export const AUTH_DEFAULT_EXPIRY_SECONDS = 300;

// Fallbacks & Prefixes
export const DEFAULT_AUTH_ISSUER_PATH = "/auth";
export const DEFAULT_BACKEND_URL_PATH = "/backend";
export const DEFAULT_AE_BACKEND_URL_PATH = "/ae-backend";
export const DEFAULT_ANSWER_ENGINE_VERSION = "main";
export const SESSION_PRESERVE_PREFIX = "elelem-answer-engine-session-";
export const I18N_LOCALE_KEY = "i18nextLng";

// Global Event & Channel Names
export const AUTH_LOGOUT_REDIRECT_EVENT = "auth:logout-redirect";
export const AUTH_BROADCAST_CHANNEL_NAME = "elelem_auth_sync";

// Peer-Sync & Multi-Tab Synchronization Constants
export const AUTH_LOCK_NAME = "elelem_auth_refresh_lock";
export const AUTH_TOKEN_EXPIRY_STORAGE_KEY = "elelem_auth_token_expires_at";
export const PEER_SYNC_WAIT_MS = 150;               // 150ms handshake wait window
export const TOKEN_SHARE_MIN_TTL_SECONDS = 10;      // Only share tokens with at least 10s remaining

// Notification Constants
export const NOTIFICATION_POLL_INTERVAL_MS = 60000;
export const NOTIFICATION_BROADCAST_CHANNEL_NAME = "elelem_notification_sync";
export const NOTIFICATION_TOAST_AUTO_DISMISS_MS = 15000;


